import { render } from "./AdminDocumentCategories.vue?vue&type=template&id=17d6f0be&scoped=true"
import script from "./AdminDocumentCategories.vue?vue&type=script&lang=js"
export * from "./AdminDocumentCategories.vue?vue&type=script&lang=js"

import "./AdminDocumentCategories.vue?vue&type=style&index=0&id=17d6f0be&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d6f0be"]])

export default __exports__